import { Box } from '@mui/material';
import 'dayjs/locale/de';

function LoginCallback() {
    return (
        <Box alignItems={'center'} justifyContent={'center'} width='100%'>  
            
        </Box>
    );
}

export default LoginCallback;